import React from "react";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { useIsFreeTrial } from "../../hooks/useUser";

// Wrap routes that free trial users shouldn't access (My Orders, Cart) so they
// bounce back to the store instead of rendering the restricted page.
export function FreeTrialGuard({ children }) {
  const isFreeTrial = useIsFreeTrial();

  if (isFreeTrial) {
    return <Redirect to="/wwg-store" />;
  }

  return children;
}

export default FreeTrialGuard;
